// import { useFormik } from 'formik';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import { Card, CardFooter } from '@components/card/card';
// import { CardBody, Form } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { addReceiveTransactions } from '@store/INV/Transactions/InvReceive/invReceiveSlice';
// import { useNavigate } from 'react-router-dom';
// import useGetTransactionTypesReceiveList from '@hooks/INV/InvReceive/useGetTransactionTypesReceiveList';
// import { TreeSelect } from 'antd';
// import useGetCustomersList from '@hooks/NTX/Peoples/useGetCustomersList';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
// import ReceiveLines from './ReceiveLines';
// import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
// import useGetSubinventoryList from '@hooks/INV/Inventories/useGetSubinventoryList';
// import { getPersonId } from '@store/Login2/authSelectors';
// import { useEffect, useState } from 'react';
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// import Loading from '@components/Shared/Loader/Loading';
// import { AddReceiveTransactionsSchema } from '@pages/ValidationForm/validationSchema';
// import TransactionStartModal from '../TransactionStart/TransactionStartModal';
// import useGetOrganizations from '@hooks/HR/use-get-organizations';

// const Add = () => {
//   const [showModal, setShowModal] = useState(true);
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();
//   const Navigate = useNavigate();

//   const { OperatingUnitOptions, loading: loading1, error: error1 } = useGetOperatingUnitWithPermission();
//   const { InventoryOptions, loading: loading2, error: error2 } = useGetInventoryWithPermission();
//   const { OperatingUnitOptions: OperatingUnitOptions2, InventoryOptions: InventoryOptions2 } = useGetOrganizations(); // وحدات التشغيل والمخازن بدون صلاحيـات

//   const { TreeSubInventoryData, loading: loading3, error: error3 } = useGetSubinventoryList();
//   const { treeCustomerData, loading: loading4, error: error4 } = useGetCustomersList();
//   const { treeSuppliersData, loading: loading5, error: error5 } = useGetSuppliersList();
//   const { OptionsTransactionTypes, loading: loading6, error: error6 } = useGetTransactionTypesReceiveList();
//   const personId = useAppSelector(getPersonId);

//   const formik = useFormik({
//     initialValues: {
//       supplierInvoiceNum: '',
//       code: '',
//       transactionDate: new Date().toISOString().split('T')[0],
//       description: '',
//       branchId: '',
//       transactionAmount: 0,
//       referenceType: '',
//       referenceCode: '',
//       referenceId: '',
//       supplierId: '',
//       customerId: '',
//       personId: personId,
//       inventoryId: '',
//       inventoryTo: '',
//       inventoryFrom: '',
//       subInventoryId: '',
//       address: '',
//       note: '',
//       transactionYear: 0,
//       materialTransactionsLineList: [] as any[]
//     },
//     enableReinitialize: true,
//     validationSchema: AddReceiveTransactionsSchema(t),
//     onSubmit: values => {
//       const Lines = values.materialTransactionsLineList?.filter(f => f.transactionQuantityIn !== 0);
//       // debugger;
//       if (Lines.length === 0) {
//         CustomAlert({ action: 'info', msg: 'لا يوجد أصناف' });
//         formik.setSubmitting(false);
//         return;
//       }

//       dispatch(
//         addReceiveTransactions({
//           code: values.code,
//           transactionDate: values.transactionDate,
//           description: values.description,
//           branchId: values.branchId,
//           transactionAmount: 0,
//           referenceType: values.referenceType,
//           referenceId: values.referenceId || null,
//           supplierId: values.supplierId || null,
//           customerId: values.customerId || null,
//           personId: values.personId || null,
//           inventoryId: values.inventoryId,
//           address: values.address,
//           note: values.note,
//           no: 0,
//           transactionYear: 0,
//           supplierInvoiceNum: values.supplierInvoiceNum,
//           subInventoryId: values.subInventoryId || null,
//           referenceCode: values.referenceCode,
//           // materialTransactionsLineList: formik.values.materialTransactionsLineList?.map((item: any) => ({
//           materialTransactionsLineList: Lines?.map((item: any) => ({
//             transactionItemId: item.transactionItemId,
//             transactionUom: item.transactionUom,
//             unitPrice: item.unitPrice,
//             // unitPrice: 0,
//             transactionQuantityIn: item.transactionQuantityIn,
//             transactionQuantityOut: 0,
//             inventoryId: null,
//             referenceIdMaster: item.referenceIdMaster || null,
//             referenceIdLine: item.referenceIdLine || null,
//             transactionTypeId: null,
//             lotId: item.lotId || null
//           }))
//         })
//       )
//         .unwrap()
//         .then((res: any) => {
//           if (res?.succeeded === true) {
//             CustomAlert({ action: 'Add' });
//             Navigate('/INV/Transactions/InvReceive', { replace: true });
//           } else {
//             CustomAlert({ action: 'Error', msg: res?.message });
//           }
//         })
//         .catch((error: any) => {
//           CustomAlert({ action: 'Error' });
//         })
//         .finally(() => formik.setSubmitting(false));
//     }
//   });

//   const { values, handleChange: formikhandleChange } = formik;

//   // console.log(values.code);
//   // POR

//   useEffect(() => {
//     if (!formik.values.branchId && OperatingUnitOptions?.length > 0) {
//       const firstOption = OperatingUnitOptions[0];
//       formik.setFieldValue('branchId', firstOption.value);
//     }
//   }, [OperatingUnitOptions]);

//   // تحديد المخزن الفرعي الأول تلقائيًا عند تغيير المخزن الرئيسي أو عند تحميل البيانات
//   useEffect(() => {
//     if (values.inventoryId && TreeSubInventoryData?.length > 0) {
//       // تصفية المخازن الفرعية التي تتبع المخزن الرئيسي المحدد
//       const filteredSubInventories = TreeSubInventoryData.filter(f => f.parentId === values.inventoryId);

//       // إذا لم يكن هناك مخزن فرعي محدد حاليًا، اختر الأول
//       if (!values.subInventoryId && filteredSubInventories.length > 0) {
//         formik.setFieldValue('subInventoryId', filteredSubInventories[0].value);
//       }
//     }
//   }, [values.inventoryId, TreeSubInventoryData]);

//   const selectedOU = OperatingUnitOptions?.find((x: any) => x.value === formik.values.branchId);
//   const selectedInv = InventoryOptions?.find((x: any) => x.value === formik.values.inventoryId);
//   const selectedType = OptionsTransactionTypes?.find((x: any) => x.value === formik.values.code);

//   const selectedInvFrom = InventoryOptions2?.find((x: any) => x.value === formik.values.inventoryFrom);

//   return (
//     <div>
//       <Breadcrumb
//         BreadcrumbList={[
//           {
//             name: t('Home'),
//             link: ':moduleHome'
//           },
//           {
//             name: t('ReceivePermission'),
//             link: ''
//           },
//           {
//             name: t('NewReceivePermission'),
//             link: null
//           }
//         ]}
//         PageName={t('NewReceivePermission')}
//       />
//       {/* ثم لفّ شاشة الإضافة بحيث لا تظهر إلا بعد إغلاق المودال: */}
//       {!showModal && (
//         <Card>
//           <Form onSubmit={formik.handleSubmit}>
//             <Loading
//               loading={loading1 || loading2 || loading3 || loading4 || loading5 || loading6}
//               error={error1 || error2 || error3 || error4 || error5 || error6}
//             >
//               <CardBody>
//                 <Card className='mb-3 border-0 bg-theme bg-opacity-10'>
//                   <div className='p-3 d-flex flex-wrap gap-4 align-items-center justify-content-between'>
//                     <div>
//                       <div className='small text-muted'>{t('OperatingUnit')}</div>
//                       <div className='fw-bold'>{selectedOU?.label ?? '-'}</div>
//                     </div>

//                     <div>
//                       <div className='small text-muted'>{t('Inventory')}</div>
//                       <div className='fw-bold'>{selectedInv?.label ?? '-'}</div>
//                     </div>

//                     {values.code === 'MOR' && (
//                       <div>
//                         <div className='small text-muted'>{t('من مخزن')}</div>
//                         <div className='fw-bold'>{selectedInvFrom?.label ?? '-'}</div>
//                       </div>
//                     )}

//                     <div>
//                       <div className='small text-muted'>{t('TransactionType')}</div>
//                       <div className='fw-bold'>{selectedType?.label ?? '-'}</div>
//                     </div>

//                     <div>
//                       <div className='small text-muted'>{t('Reference')}</div>
//                       <div className='fw-bold'>{formik.values.referenceCode || formik.values.referenceId || '-'}</div>
//                     </div>
//                   </div>
//                 </Card>

//                 <div className='row '>
//                   <div className='col-lg-4'>
//                     <div className='form-group mb-3'>
//                       <label className='form-label'>{t('Date')}</label>
//                       <Form.Control
//                         className='form-control  text-center'
//                         type='date'
//                         name='transactionDate'
//                         onChange={formikhandleChange}
//                         value={values.transactionDate || ''}
//                       />
//                       <div className='text-danger small'>
//                         {formik.touched.transactionDate && formik.errors.transactionDate}
//                       </div>
//                     </div>
//                   </div>

//                   {['SPR', 'POR'].includes(values.code) && (
//                     <>
//                       <div className='col-lg-4'>
//                         <div className='form-group mb-3'>
//                           <label className='form-label'>{t('Supplier')}</label>
//                           <TreeSelect
//                             disabled
//                             showSearch
//                             className='w-100'
//                             treeLine
//                             placeholder={t('Choose')}
//                             allowClear
//                             treeDefaultExpandAll={false}
//                             value={values.supplierId}
//                             onChange={(option: any) => {
//                               formik.setFieldValue('supplierId', option === null ? null : option);
//                             }}
//                             loading={loading4}
//                             treeData={treeSuppliersData}
//                             treeNodeFilterProp='title'
//                           />
//                           <div className='text-danger small'>
//                             {formik.touched.supplierId && formik.errors.supplierId}
//                           </div>
//                         </div>
//                       </div>

//                       <div className='col-lg-4'>
//                         <div className='form-group mb-3'>
//                           <label className='form-label'>{t('SupplierInvoiceNumber')}</label>
//                           <Form.Control
//                             className='form-control  text-center'
//                             type='text'
//                             name='supplierInvoiceNum'
//                             onChange={formikhandleChange}
//                             value={values.supplierInvoiceNum || ''}
//                           />
//                           <div className='text-danger small'>
//                             {formik.touched.supplierInvoiceNum && formik.errors.supplierInvoiceNum}
//                           </div>
//                         </div>
//                       </div>
//                     </>
//                   )}

//                   {['INV', 'SOI'].includes(values.code) && (
//                     <div className='col-lg-4'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('Customer')}</label>
//                         <TreeSelect
//                           disabled
//                           showSearch
//                           className='w-100'
//                           treeLine
//                           allowClear
//                           treeDefaultExpandAll={false}
//                           value={values.customerId}
//                           onChange={(option: any) => {
//                             formik.setFieldValue('customerId', option === null ? null : option);
//                           }}
//                           treeData={treeCustomerData}
//                           loading={loading4}
//                           treeNodeFilterProp='title'
//                           placeholder={t('Choose')}
//                         />
//                         <div className='text-danger small'>{formik.touched.customerId && formik.errors.customerId}</div>
//                       </div>
//                     </div>
//                   )}

//                   <div className='col-lg-12'>
//                     <div className='form-group mb-3'>
//                       <label className='form-label'>{t('Description')}</label>
//                       <Form.Control
//                         autoComplete='off'
//                         className='form-control'
//                         as='textarea'
//                         rows={1}
//                         name='description'
//                         onChange={formik.handleChange}
//                         value={values.description}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </CardBody>

//               <CardFooter className='shadow-sm px-0  '>
//                 <ReceiveLines formik={formik} />
//               </CardFooter>
//               <div className='text-center mt-3'>
//                 <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg me-1 btn-theme mb-1'>
//                   {formik.isSubmitting ? (
//                     <div className='spinner-border spinner-border-sm me-2'></div>
//                   ) : (
//                     <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
//                   )}
//                   {t('Add')}
//                 </button>
//                 <button type='button' className='btn btn-lg  me-1 btn-default mb-1' onClick={() => Navigate(-1)}>
//                   <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//                 </button>
//               </div>
//             </Loading>
//           </Form>
//         </Card>
//       )}

//       <TransactionStartModal
//         show={showModal}
//         onCancel={() => Navigate('/INV/Transactions/InvReceive')}
//         onConfirm={({ branchId, inventoryId, code, referenceId, referenceCode }) => {
//           formik.setFieldValue('branchId', branchId);
//           formik.setFieldValue('inventoryId', inventoryId);
//           formik.setFieldValue('code', code);
//           formik.setFieldValue('referenceId', referenceId);
//           formik.setFieldValue('referenceCode', referenceCode);
//           formik.setFieldValue('materialTransactionsLineList', []);
//           setShowModal(false);
//         }}
//         OperatingUnitOptions={OperatingUnitOptions}
//         InventoryOptions={InventoryOptions}
//         OptionsTransactionTypes={OptionsTransactionTypes}
//         loading={loading1 || loading2 || loading6}
//         error={error1 || error2 || error6}
//         requireReference={true}
//         //
//         headerTitle={i18n.language === 'ar' ? ' إذن إضافة مخزنية' : ' Inventory Receive'}
//         headerSubtitle={
//           i18n.language === 'ar'
//             ? 'اختر نوع الإضافة ثم الوحدة والمخزن والمرجع'
//             : 'Choose receive type, OU, inventory and reference'
//         }
//         headerIconClassName='fas fa-arrow-down'
//       />
//     </div>
//   );
// };

// export default Add;

import { useFormik } from 'formik';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { Card, CardFooter, CardHeader } from '@components/card/card';
import { Button, CardBody, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { addReceiveTransactions } from '@store/INV/Transactions/InvReceive/invReceiveSlice';
import { useNavigate } from 'react-router-dom';
import useGetTransactionTypesReceiveList from '@hooks/INV/InvReceive/useGetTransactionTypesReceiveList';
import { TreeSelect } from 'antd';
import useGetCustomersList from '@hooks/NTX/Peoples/useGetCustomersList';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import ReceiveLines from './ReceiveLines';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
import useGetSubinventoryList from '@hooks/INV/Inventories/useGetSubinventoryList';
import { getPersonId } from '@store/Login2/authSelectors';
import { useEffect, useState } from 'react';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import Loading from '@components/Shared/Loader/Loading';
import { AddReceiveTransactionsSchema } from '@pages/ValidationForm/validationSchema';
import TransactionStartModal from '../TransactionStart/TransactionStartModal';
import useGetOrganizations from '@hooks/HR/use-get-organizations';
import FileUpload from '@components/Files/FileUpload';

const Add = () => {
  const [showModal, setShowModal] = useState(true);
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const Navigate = useNavigate();
  // const [attach, setAttach] = useState<any[]>([]);

  const { OperatingUnitOptions, loading: loading1, error: error1 } = useGetOperatingUnitWithPermission();
  const { InventoryOptions, loading: loading2, error: error2 } = useGetInventoryWithPermission();
  const { OperatingUnitOptions: OperatingUnitOptions2, InventoryOptions: InventoryOptions2 } = useGetOrganizations(); // وحدات التشغيل والمخازن بدون صلاحيـات

  const { TreeSubInventoryData, loading: loading3, error: error3 } = useGetSubinventoryList();
  const { treeCustomerData, loading: loading4, error: error4 } = useGetCustomersList();
  const { treeSuppliersData, loading: loading5, error: error5 } = useGetSuppliersList();
  const { OptionsTransactionTypes, loading: loading6, error: error6 } = useGetTransactionTypesReceiveList();
  const personId = useAppSelector(getPersonId);

  const formik = useFormik({
    initialValues: {
      supplierInvoiceNum: '',
      code: '',
      transactionDate: new Date().toISOString().split('T')[0],
      description: '',
      branchId: '',
      transactionAmount: 0,
      referenceType: '',
      referenceCode: '',
      referenceId: '',
      supplierId: '',
      customerId: '',
      personId: personId,
      inventoryId: '',
      inventoryTo: '',
      inventoryFrom: '',
      subInventoryId: '',
      address: '',
      note: '',
      transactionYear: 0,
      fileAttachment: [] as File[],
      materialTransactionsLineList: [] as any[]
    },
    enableReinitialize: true,
    validationSchema: AddReceiveTransactionsSchema(t),
    onSubmit: values => {
      const Lines = values.materialTransactionsLineList?.filter(f => f.transactionQuantityIn !== 0);
      // debugger;
      if (Lines.length === 0) {
        CustomAlert({ action: 'info', msg: 'لا يوجد أصناف' });
        formik.setSubmitting(false);
        return;
      }

      dispatch(
        addReceiveTransactions({
          code: values.code,
          transactionDate: values.transactionDate,
          description: values.description,
          branchId: values.branchId,
          transactionAmount: 0,
          referenceType: values.referenceType,
          referenceId: values.referenceId || null,
          supplierId: values.supplierId || null,
          customerId: values.customerId || null,
          personId: values.personId || null,
          inventoryId: values.inventoryId,
          address: values.address,
          note: values.note,
          no: 0,
          transactionYear: 0,
          supplierInvoiceNum: values.supplierInvoiceNum,
          subInventoryId: values.subInventoryId || null,
          referenceCode: values.referenceCode,
          fileAttachment: values.fileAttachment, // ✅ جديد
          // materialTransactionsLineList: formik.values.materialTransactionsLineList?.map((item: any) => ({
          materialTransactionsLineList: Lines?.map((item: any) => ({
            transactionItemId: item.transactionItemId,
            transactionUom: item.transactionUom,
            unitPrice: item.unitPrice,
            // unitPrice: 0,
            transactionQuantityIn: item.transactionQuantityIn,
            transactionQuantityOut: 0,
            inventoryId: null,
            referenceIdMaster: item.referenceIdMaster || null,
            referenceIdLine: item.referenceIdLine || null,
            transactionTypeId: null,
            lotId: item.lotId || null
          }))
        })
      )
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Add' });
            Navigate('/INV/Transactions/InvReceive', { replace: true });
          } else {
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    }
  });

  const { values, handleChange: formikhandleChange } = formik;
  // console.log(formik.errors);

  // const handleUpload: React.Dispatch<React.SetStateAction<File[]>> = value => {
  //   setAttach(prev => {
  //     const newAttachments = typeof value === 'function' ? value(prev) : value;
  //     if (newAttachments.length > 0) {
  //       formik.setFieldValue('Img', newAttachments[0]);
  //       formik.setFieldValue('IsUpdateIMG', true);
  //     } else {
  //       formik.setFieldValue('Img', '');
  //       formik.setFieldValue('IsUpdateIMG', false);
  //     }
  //     return newAttachments;
  //   });
  // };

  useEffect(() => {
    if (!formik.values.branchId && OperatingUnitOptions?.length > 0) {
      const firstOption = OperatingUnitOptions[0];
      formik.setFieldValue('branchId', firstOption.value);
    }
  }, [OperatingUnitOptions]);

  // تحديد المخزن الفرعي الأول تلقائيًا عند تغيير المخزن الرئيسي أو عند تحميل البيانات
  useEffect(() => {
    if (values.inventoryId && TreeSubInventoryData?.length > 0) {
      // تصفية المخازن الفرعية التي تتبع المخزن الرئيسي المحدد
      const filteredSubInventories = TreeSubInventoryData.filter(f => f.parentId === values.inventoryId);

      // إذا لم يكن هناك مخزن فرعي محدد حاليًا، اختر الأول
      if (!values.subInventoryId && filteredSubInventories.length > 0) {
        formik.setFieldValue('subInventoryId', filteredSubInventories[0].value);
      }
    }
  }, [values.inventoryId, TreeSubInventoryData]);

  const selectedOU = OperatingUnitOptions?.find((x: any) => x.value === formik.values.branchId);
  const selectedInv = InventoryOptions?.find((x: any) => x.value === formik.values.inventoryId);
  const selectedType = OptionsTransactionTypes?.find((x: any) => x.value === formik.values.code);

  const selectedInvFrom = InventoryOptions2?.find((x: any) => x.value === formik.values.inventoryFrom);

  // const setFormikAttachments: React.Dispatch<React.SetStateAction<File[]>> = updater => {
  //   const next = typeof updater === 'function' ? updater(formik.values.fileAttachment) : updater;

  //   formik.setFieldValue('fileAttachment', next);
  //   // اختياري: لو عندك فاليديشن على المرفقات
  //   // formik.setFieldTouched('fileAttachment', true, true);
  // };

  return (
    <div>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: t('Home'),
            link: ':moduleHome'
          },
          {
            name: t('ReceivePermission'),
            link: ''
          },
          {
            name: t('NewReceivePermission'),
            link: null
          }
        ]}
        PageName={t('NewReceivePermission')}
      />
      {/* ثم لفّ شاشة الإضافة بحيث لا تظهر إلا بعد إغلاق المودال: */}
      {!showModal && (
        <>
          <Form onSubmit={formik.handleSubmit}>
            <Loading
              loading={loading1 || loading2 || loading3 || loading4 || loading5 || loading6}
              error={error1 || error2 || error3 || error4 || error5 || error6}
            >
              <Card>
                <CardBody>
                  <Card className='mb-3 border-0 bg-theme bg-opacity-10'>
                    <div className='p-3 d-flex flex-wrap gap-4 align-items-center justify-content-between'>
                      <div>
                        <div className='small text-muted'>{t('OperatingUnit')}</div>
                        <div className='fw-bold'>{selectedOU?.label ?? '-'}</div>
                      </div>

                      <div>
                        <div className='small text-muted'>{t('Inventory')}</div>
                        <div className='fw-bold'>{selectedInv?.label ?? '-'}</div>
                      </div>

                      {values.code === 'MOR' && (
                        <div>
                          <div className='small text-muted'>{t('من مخزن')}</div>
                          <div className='fw-bold'>{selectedInvFrom?.label ?? '-'}</div>
                        </div>
                      )}

                      <div>
                        <div className='small text-muted'>{t('TransactionType')}</div>
                        <div className='fw-bold'>{selectedType?.label ?? '-'}</div>
                      </div>

                      <div>
                        <div className='small text-muted'>{t('Reference')}</div>
                        <div className='fw-bold'>{formik.values.referenceCode || formik.values.referenceId || '-'}</div>
                      </div>
                    </div>
                  </Card>

                  <div className='row '>
                    <div className='col-lg-4'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('Date')}</label>
                        <Form.Control
                          className='form-control  text-center'
                          type='date'
                          name='transactionDate'
                          onChange={formikhandleChange}
                          value={values.transactionDate || ''}
                        />
                        <div className='text-danger small'>
                          {formik.touched.transactionDate && formik.errors.transactionDate}
                        </div>
                      </div>
                    </div>

                    {['SPR', 'POR'].includes(values.code) && (
                      <>
                        <div className='col-lg-4'>
                          <div className='form-group mb-3'>
                            <label className='form-label'>{t('Supplier')}</label>
                            <TreeSelect
                              disabled
                              showSearch
                              className='w-100'
                              treeLine
                              placeholder={t('Choose')}
                              allowClear
                              treeDefaultExpandAll={false}
                              value={values.supplierId}
                              onChange={(option: any) => {
                                formik.setFieldValue('supplierId', option === null ? null : option);
                              }}
                              loading={loading4}
                              treeData={treeSuppliersData}
                              treeNodeFilterProp='title'
                            />
                            <div className='text-danger small'>
                              {formik.touched.supplierId && formik.errors.supplierId}
                            </div>
                          </div>
                        </div>

                        <div className='col-lg-4'>
                          <div className='form-group mb-3'>
                            <label className='form-label'>{t('SupplierInvoiceNumber')}</label>
                            <Form.Control
                              className='form-control  text-center'
                              type='text'
                              name='supplierInvoiceNum'
                              onChange={formikhandleChange}
                              value={values.supplierInvoiceNum || ''}
                            />
                            <div className='text-danger small'>
                              {formik.touched.supplierInvoiceNum && formik.errors.supplierInvoiceNum}
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {['INV', 'SOI'].includes(values.code) && (
                      <div className='col-lg-4'>
                        <div className='form-group mb-3'>
                          <label className='form-label'>{t('Customer')}</label>
                          <TreeSelect
                            disabled
                            showSearch
                            className='w-100'
                            treeLine
                            allowClear
                            treeDefaultExpandAll={false}
                            value={values.customerId}
                            onChange={(option: any) => {
                              formik.setFieldValue('customerId', option === null ? null : option);
                            }}
                            treeData={treeCustomerData}
                            loading={loading4}
                            treeNodeFilterProp='title'
                            placeholder={t('Choose')}
                          />
                          <div className='text-danger small'>
                            {formik.touched.customerId && formik.errors.customerId}
                          </div>
                        </div>
                      </div>
                    )}

                    <div className='col-lg-12'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('Description')}</label>
                        <Form.Control
                          autoComplete='off'
                          className='form-control'
                          as='textarea'
                          rows={1}
                          name='description'
                          onChange={formik.handleChange}
                          value={values.description}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>

                <CardFooter className='shadow-sm px-0  '>
                  <ReceiveLines formik={formik} />
                </CardFooter>
              </Card>

              <Card className=' mt-3'>
                <CardHeader className=''>
                  <Form.Label className='m-0'>{t('Attachments')}</Form.Label>
                </CardHeader>
                <CardBody>
                  <div className='form-group mb-3'>
                    <FileUpload
                      attachments={formik.values.fileAttachment}
                      setAttachments={(updater: any) => {
                        const next = typeof updater === 'function' ? updater(formik.values.fileAttachment) : updater;

                        formik.setFieldValue('fileAttachment', next);
                        // اختياري لو عندك فاليديشن على المرفقات
                        // formik.setFieldTouched('fileAttachment', true, true);
                      }}
                      multiple={false}
                    />
                  </div>
                </CardBody>
              </Card>

              <Card className='p-2 mt-3'>
                <div className='text-end  '>
                  <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg me-1 btn-theme  rounded-0'>
                    {formik.isSubmitting ? (
                      <div className='spinner-border spinner-border-sm me-2'></div>
                    ) : (
                      <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
                    )}
                    {t('Add')}
                  </button>

                  <button type='button' className=' btn btn-lg me-1 btn-default rounded-0' onClick={() => Navigate(-1)}>
                    <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
                  </button>
                </div>
              </Card>
            </Loading>
          </Form>
        </>
      )}

      <TransactionStartModal
        show={showModal}
        onCancel={() => Navigate('/INV/Transactions/InvReceive')}
        onConfirm={({ branchId, inventoryId, code, referenceId, referenceCode }) => {
          formik.setFieldValue('branchId', branchId);
          formik.setFieldValue('inventoryId', inventoryId);
          formik.setFieldValue('code', code);
          formik.setFieldValue('referenceId', referenceId);
          formik.setFieldValue('referenceCode', referenceCode);
          formik.setFieldValue('materialTransactionsLineList', []);
          setShowModal(false);
        }}
        OperatingUnitOptions={OperatingUnitOptions}
        InventoryOptions={InventoryOptions}
        OptionsTransactionTypes={OptionsTransactionTypes}
        loading={loading1 || loading2 || loading6}
        error={error1 || error2 || error6}
        requireReference={true}
        //
        headerTitle={i18n.language === 'ar' ? ' إذن إضافة مخزنية' : ' Inventory Receive'}
        headerSubtitle={
          i18n.language === 'ar'
            ? 'اختر نوع الإضافة ثم الوحدة والمخزن والمرجع'
            : 'Choose receive type, OU, inventory and reference'
        }
        headerIconClassName='fas fa-arrow-down'
      />
    </div>
  );
};

export default Add;
